/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
 import { APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbCardModule, 
  NbThemeModule,
  NbLayoutModule,
  NbToastrModule,
  NbWindowModule,
  NbButtonModule,
} from '@nebular/theme';
import { NgxAuthModule } from './auth/auth/auth.module';

//import { LanguageService } from './@core/services/language/language.service';
 ;
 import { AuthorizeComponent } from './auth/components/authorize/authorize.component';




@NgModule({
  declarations: [AppComponent, AuthorizeComponent ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbCardModule, 
    NbThemeModule,
    NbLayoutModule,
    NbButtonModule,
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    NgxAuthModule,
 
    ThemeModule.forRoot(),
  ],
  
 
  bootstrap: [AppComponent],
})
export class AppModule {
}
